import { render, staticRenderFns } from "./visitor-privacy-policy.vue?vue&type=template&id=769829fc&scoped=true&"
import script from "./visitor-privacy-policy.vue?vue&type=script&lang=ts&"
export * from "./visitor-privacy-policy.vue?vue&type=script&lang=ts&"
import style0 from "./visitor-privacy-policy.vue?vue&type=style&index=0&id=769829fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "769829fc",
  null
  
)

export default component.exports